export const tokenScope = effectScope();

export const useAuthToken = createGlobalState(() => {
    const authToken = useStorage('authToken', ref(''), localStorage, {
        deep: true,
        writeDefaults: true,
        listenToStorageChanges: true,
    });

    const brand = useStorage('brand', ref(''), localStorage, {
        deep: true,
        writeDefaults: true,
        listenToStorageChanges: true,
    });

    const dropdownDisabled = useStorage('dropdownDisabled', ref(false), localStorage, {
        deep: true,
        writeDefaults: true,
        listenToStorageChanges: true,
    });

    return {
        authToken,
        brand,
        dropdownDisabled,
    };
});

export const initToken = () => {
    tokenScope.run(() => {
        const { authToken } = useAuthToken();

        console.log('initToken：', authToken.value);
    });
};
